import * as Realm from "realm-web";

// TODO: Add your Stitch app's App ID
const APP_ID = "roadmapedia-cbfvz";

// TODO: Initialize the app client
const app = new Realm.App({ id: APP_ID });

export { app };
